import { render, staticRenderFns } from "./Shadow.vue?vue&type=template&id=b9c3df3a&scoped=true"
import script from "./Shadow.vue?vue&type=script&lang=js"
export * from "./Shadow.vue?vue&type=script&lang=js"
import style0 from "./Shadow.vue?vue&type=style&index=0&id=b9c3df3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c3df3a",
  null
  
)

export default component.exports